export const environmentversion = {
  version : 'origin/GPFJ(1d7bf96537da50c23ec3b07717f86f3990240dc1)'
};